import { DAY, MINUTE } from '../time'

export const PROSPECT_STAGE_COLOR = '#A5B4FC'
export const DEFAULT_UNDO_ACTION_TIME_SINCE = DAY / MINUTE // 1 day in minutes
export const DEFAULT_NOTE_TIMEFRAME_MS = DAY // 24 hours in milliseconds
